import { AppContent } from 'content/AppContent';

import bosIllustrationPeople from '../../assets/common/bos-illustration-people.svg';

// FullSignatoryPage content for BOS
const fullSignatoryPage: AppContent['fullSignatoryPage'] = {
  fullSignatoryPageContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'Are you a Full Signatory on the bank mandate?',
      content:
        'You are a Full Signatory if you can change who accesses your business accounts, authorise payments and apply for new products and services.',
      imageAltText: '',
      imageSrc: bosIllustrationPeople,
      yesBtn: 'Yes',
      yesBtnHref: '/approve-your-registration',
      noBtn: 'No',
      noBtnHref: '/three-steps-to-register',
      previousLink: 'Previous',
      previousHref: '/',
      faqHeader: 'Need some help?',
      faq: [
        {
          question: '',
          answer: '',
        },
      ],
    },
  ],
};

export default fullSignatoryPage;
